export default {"src":"/_next/static/media/master.a96acc7b.svg","height":22,"width":34,"blurWidth":0,"blurHeight":0};